import store from "store";
import Axios from "./Axios";
import branchServices from "./branchServices";
import vendorServices from "./vendorServices";

const services = {
  vendor: vendorServices,
  branch: branchServices,
};

export const roleService = (SelectedRole) => {
  const role = SelectedRole ?? store.getState().auth.userRole;
  return {
    login: async (obj) => {
      const { data } = await Axios.post(`${role}/login`, obj);
      return data;
    },

    getRecoveryCode: async (email) => {
      const { data } = await Axios.post(`${role}/recovery`, { email });
      return data;
    },
    resetPassword: async (obj, token) => {
      const { data } = await Axios.put(`${role}/resetPassword`, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    },

    listAllBranchProductsOfType: async (vendor, branch, isHotDeal = false) => {
      const response = await Axios.get(
        `/${role}/product/list?isHotDeal=${isHotDeal}`,
        { params: { vendor, branch, isActive: true } }
      );
      return response;
    },

    listCashier: async (params) => {
      const response = await Axios.get(`/${role}/cashier/list`, { params });
      return response.data;
    },

    //
    listAllJobs: async (params) => {
      const response = await Axios.get(`/${role}/job/list`, { params });
      return response.data;
    },
    getJobDetails: async (_id) => {
      const response = await Axios.get(`/${role}/job/get`, { params: { _id } });
      return response.data;
    },
    createJob: async (obj) => {
      const response = await Axios.post(`/${role}/job/create`, obj);
      return response.data;
    },
    removeJob: async (_id) => {
      const response = await Axios.delete(`/${role}/job/remove`, {
        params: { _id },
      });
      return response.data;
    },

    listAllCategories: async (params) => {
      const response = await Axios.get(`/${role}/category/list`, { params });
      return response.data;
    },

    listAllPages: async () => {
      const response = await Axios.get(`/page/list`);
      return response?.data?.records ?? response?.data?.record;
    },
    listAllSettings: async () => {
      const response = await Axios.get(`/setting/get`);
      return response?.data?.records ?? response?.data?.record;
    },

    listAllOrderRequests: async (params) => {
      const response = await Axios.get(`/${role}/orderRequest/get`, { params });
      return response?.data?.records ?? response?.data?.record;
    },
    updateOrderRequest: async (obj) => {
      const { status, rejectionReasons, shippingFees, ...rest } = obj;
      const response = await Axios.put(
        `/${role}/orderRequest/update`,
        {
          status,
          rejectionReasons,
          shippingFees,
        },
        {
          params: {
            ...rest,
          },
        }
      );
      return response?.data?.records ?? response?.data?.record;
    },
  };
};
export default services;
